<template>
    <div class="light-color-bg position-relative">
        <QuestionTitle number="08" :question="question" :comment="comment"></QuestionTitle>
        <div class="container-70">
            <SuperficieEvent v-model="result"></SuperficieEvent>
            <div v-if="result!=null" @click="saveAndContinue('superficie', JSON.stringify(result), '/resultats')"  class="btn-primary d-block w-100 mt-50px text-center">Suivant</div>
            <AvancementLine percent="100%" class="mt-50px"></AvancementLine>
        </div>
    </div>
</template>
<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import AvancementLine from '@/components/AvancementLine.vue'
import SuperficieEvent from '@/components/SuperficieEvent.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result:null,
            question:'Votre évènement couvre environ quelle superficie? ',
            comment:'Si l’évènement se déroule sur plusieurs étages, ne pas oublier de les additionner.'
        }
    },
    components: {
        QuestionTitle,
        SuperficieEvent,
        AvancementLine
    },
    mixins:[utils],
    mounted(){
        if(sessionStorage.getItem('superficie')){
            this.result=JSON.parse(sessionStorage.getItem('superficie'))
        }
    }
}
</script>